'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIHelpIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIIcon = require('./UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _colors = require('HubStyleTokens/colors');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_DARK = 'on-dark';
var USE_DEFAULT = 'default';

function UIHelpIcon(props) {
  var use = props.use,
      tooltipPlacement = props.tooltipPlacement,
      tooltipProps = props.tooltipProps,
      title = props.title,
      className = props.className,
      style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ['use', 'tooltipPlacement', 'tooltipProps', 'title', 'className', 'style', 'children']);

  var iconColor = use === USE_DARK ? _colors.OLAF : _colors.EERIE;

  var classes = (0, _classNames2.default)('private-help-icon', className, {
    'private-help-icon--inline': children
  });

  return _react2.default.createElement(
    'span',
    { className: classes, style: style },
    children,
    _react2.default.createElement(
      _UITooltip2.default,
      _extends({}, tooltipProps, { placement: tooltipPlacement, title: title }),
      _react2.default.createElement(_UIIcon2.default, _extends({
        className: 'private-help-icon__icon',
        name: 'info',
        color: iconColor
      }, rest))
    )
  );
}

UIHelpIcon.defaultProps = {
  use: USE_DEFAULT
};

UIHelpIcon.propTypes = {
  size: _UIIcon2.default.propTypes.size,
  color: _UIIcon2.default.propTypes.color,
  use: _react.PropTypes.oneOf([USE_DARK, USE_DEFAULT]),
  tooltipPlacement: (0, _decorators.notRequired)(_UITooltip2.default.propTypes.placement),
  tooltipProps: (0, _passthroughProps2.default)(_UITooltip2.default),
  title: _react.PropTypes.node.isRequired,
  children: _react.PropTypes.node
};

UIHelpIcon.displayName = 'UIHelpIcon';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/icon/UIHelpIcon.js
// module id = 558
// module chunks = 171